import { EMAIL_EXCLUDED_CREATE_PROFILE, FREE_EMAIL_PROVIDERS, EMAIL_PATTERN, NUMBER_PATTERN, RESERVED_EMAILS, } from "./validate.const";
var validate = {
    isEmpty: function (value) {
        return value == null || value === "";
    },
    isNotEmail: function (value) {
        var valueWithoutSpaces = value.trim();
        return (validate.isEmpty(valueWithoutSpaces) ||
            !EMAIL_PATTERN.test(String(valueWithoutSpaces).toLowerCase()) ||
            FREE_EMAIL_PROVIDERS.find(function (email) { return email === valueWithoutSpaces.split("@")[1]; }) ||
            RESERVED_EMAILS.find(function (email) { return email === valueWithoutSpaces.split("@")[0]; }));
    },
    isNotValidEmail: function (value) {
        var valueWithoutSpaces = value.trim();
        return (validate.isEmpty(valueWithoutSpaces) ||
            !EMAIL_PATTERN.test(String(valueWithoutSpaces).toLowerCase()));
    },
    isEmailExcluded: function (value) {
        var emailDomainName = value.trim().split("@")[1].toLowerCase();
        var domainNames = emailDomainName.split(".");
        var _loop_1 = function (i) {
            var domainNameSection = domainNames[i];
            if (EMAIL_EXCLUDED_CREATE_PROFILE.find(function (email) { return domainNameSection === email; })) {
                return { value: true };
            }
        };
        for (var i = 0; i < domainNames.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    },
    isNotNumber: function (value) {
        return validate.isEmpty(value) || !NUMBER_PATTERN.test(String(value));
    },
    isNotWord: function (value) {
        var valueWithSpaces = value.trim();
        var letters = /^[a-zA-Z\s]+$/;
        if (!valueWithSpaces.match(letters) || validate.isEmpty(valueWithSpaces)) {
            return true;
        }
        else {
            return false;
        }
    },
};
export default validate;
